import cx from 'classnames';
import GestureTapIcon from '../../icons/gesture_tap.svg?react';
import { useI18n } from '../../i18n';
import { onboardingDismissed } from '../../state/onboarding';
import styles from './OnboardingOverlay.module.css';

type OnboardingOverlayProps = {
  visible: boolean;
};

export const OnboardingOverlay = ({ visible }: OnboardingOverlayProps) => {
  const i18n = useI18n();
  return (
    <div
      className={cx(styles.overlay, visible && styles.visible)}
      onClick={() => onboardingDismissed()}
    >
      <div className={styles.content}>
        <GestureTapIcon className={styles.icon} />
        <h2 className={styles.title}>{i18n.onboarding.title}</h2>
        <p className={styles.hint}>{i18n.onboarding.hint}</p>
      </div>
    </div>
  );
};
